encodeAndEscapeURIComponent = (str) ->
  encodeURIComponent(str).replace /\'/g, "\\'"

class Groupon.SharingButtons

  constructor: ({el, @merchantPage, facebookSelector, twitterSelector, emailSelector}) ->
    facebookSelector ?= '.icon-facebook'
    emailSelector ?= '.icon-email'
    twitterSelector ?= '.icon-twitter'

    @$el = $ el

    @$el.find(facebookSelector).on 'click', @facebookShare
    @$el.find(twitterSelector).on 'click', @twitterShare
    @$el.find(emailSelector).on 'click', @emailShare

    this

  popUpOptions: (width = 600, height = 450) ->
    left = Math.floor(Math.abs($(window).width() - width) / 2)
    top = Math.floor(Math.abs($(window).height() - height) / 2)
    "status=1,width=#{width},height=#{height},left=#{left},top=#{top}"

  facebookShare: (e) =>
    e.preventDefault()
    url = @constructMerchantPageLinkWithTracking 'facebook'
    url = "https://www.facebook.com/sharer/sharer.php?u=#{encodeAndEscapeURIComponent(url)}"
    window.open url, 'facebook', @popUpOptions()

  twitterShare: (e) =>
    e.preventDefault()
    url = @constructMerchantPageLinkWithTracking 'twitter'
    text = @merchantPage.twitterBody
    url = "http://twitter.com/share?url=#{encodeAndEscapeURIComponent(url)}&text=#{encodeAndEscapeURIComponent(text)}"
    window.open url, 'tweet', @popUpOptions()

  emailShare: (e) =>
    e.preventDefault()
    link = @constructMerchantPageLinkWithTracking 'email'
    subject = @merchantPage.emailSubject
    body = "#{@merchantPage.emailBody}\n\n#{link}"
    window.open "mailto:?subject=#{encodeURIComponent(subject)}&body=#{encodeURIComponent(body)}", 'email', @popUpOptions()

  constructMerchantPageLink: (permalink) ->
    "https://#{window.location.host}/biz/#{permalink}"

  constructMerchantPageLinkWithTracking: (medium) ->
    queryParams = _.extend (@merchantPage.queryParams or {}),
      utm_campaign: @merchantPage.campaign
      utm_medium: medium

    "#{@constructMerchantPageLink(@merchantPage.permalink)}?#{$.param(queryParams)}"
